import { IconButton } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Field, reduxForm } from 'redux-form';
import CloudKeyOutlineIconCustom from '../../CustomIcons/CloudKeyOutlineIconCustom.jsx';
import CopyIconCustom from '../../CustomIcons/CopyIconCustom.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer';
import CustomField from '../Fields/CustomField';
import MDCheckBoxGroupField from '../Fields/MDCheckBox/MDCheckBoxGroupField.js';
import MDSwitchField from '../Fields/MDSwitch/MDSwitchField.jsx';
import Office365ScimProvisioningSection from '../../Settings/OperationalSettings/Office365ScimProvisioningSection.jsx';

const SAML_LOGIN_PLATFORM_OPTIONS = [
  { value: 'FE', label: <Entity entity="samlLoginPlatformFE" /> },
  { value: 'APP', label: <Entity entity="samlLoginPlatformAPP" /> },
];

const validate = values => {
  const errors = {};

  if (!values.metadata) {
    errors.metadata = 'required';
  }
  return errors;
};

@reduxForm({ form: 'SamlSsoConfigurationForm', validate })
class SamlSsoConfigurationForm extends React.Component {
  

  render() {
    const {
      formValues,
      isOfficeSSOActive,
    } = this.props;
    const pageTitleEntity = isOfficeSSOActive ? 'microsoft365IdentityTitle' : 'samlSSOConfiguration';
    const pageDescriptionEntity = isOfficeSSOActive ? 'microsoft365IdentityDescription' : 'samlSSOConfigurationDescription';
    const isSamlUserCreationEnabled = !!(formValues && formValues.enableUserCreation);
    const samlProvisioningMappingDisabled = !isSamlUserCreationEnabled;
    const managerRoleValueDisabled = !isSamlUserCreationEnabled && !isOfficeSSOActive;
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
          <CloudKeyOutlineIconCustom style={{ marginRight: 10, marginTop: 0, width: 30, color: '#3f3f3f' }} />
          <h4 style={{ fontSize: 20, margin: 0, color: '#3f3f3f', fontWeight: 'bold', lineHeight: '1.5em' }}><Entity entity={pageTitleEntity} /></h4>
        </div>
          <h4 style={{ fontSize: 20, marginTop: 0, color: '#3f3f3f', lineHeight: '1.5em' }}><Entity entity={pageDescriptionEntity} /></h4>
        <FormFlatContainer
          containerStyle={{ marginRight: 10, marginTop: 10}}
          headerStyle={{ marginBottom: 0 }}
        >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
          <div>
            <h4 style={{ fontSize: 16, marginTop: 0, marginBottom: 0, color: '#3f3f3f', fontWeight: 'bold', lineHeight: '1.5em' }}><Entity entity="assertionConsumerUrl" /></h4>
            <h4 style={{ fontSize: 16, marginTop: 0, marginBottom: 20, color: '#3f3f3f', fontWeight: 'normal', lineHeight: '1.5em' }}>{formValues && formValues.assertionConsumerUrl ? formValues.assertionConsumerUrl : ''}</h4>
          </div>
          {formValues && formValues.assertionConsumerUrl ? (
            <CopyToClipboard text={formValues.assertionConsumerUrl} onCopy={() => {}}>
              <IconButton>
                <CopyIconCustom style={{ width: 20, color: '#3f3f3f' }} />
              </IconButton>
            </CopyToClipboard>
          ) : null}
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
          <div>
            <h4 style={{ fontSize: 16, marginTop: 0, marginBottom: 0, color: '#3f3f3f', fontWeight: 'bold', lineHeight: '1.5em' }}><Entity entity="relyingPartyIdentifier" /></h4>
            <h4 style={{ fontSize: 16, marginTop: 0, marginBottom: 0, color: '#3f3f3f', fontWeight: 'normal', lineHeight: '1.5em' }}>{formValues && formValues.relyingPartyIdentifier ? formValues.relyingPartyIdentifier : ''}</h4>
          </div>
          {formValues && formValues.relyingPartyIdentifier ? (
            <CopyToClipboard text={formValues.relyingPartyIdentifier} onCopy={() => {}}>
              <IconButton>
                <CopyIconCustom style={{ width: 20, color: '#3f3f3f' }} />
              </IconButton>
            </CopyToClipboard>
          ) : null}
        </div>
          <Entity
            title={<Entity entity="metadata" />}
            componentClass={Field}
            name="metadata"
            componentAttribute="placeholder"
            entity="insertMetadata"
            component={CustomField}
            containerStyle={{ marginTop: 30 }}
            type="textarea"
            areaStyle={{ height: 300 }}
            className="form-control-custom"
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="samlLoginSettingsTitle"
          subtitle="samlLoginSettingsDescription"
          containerStyle={{ marginRight: 10, marginTop: 10 }}
        >
          <Field
            name="exclusiveLogin"
            label={<Entity entity="samlExclusiveLogin" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold' }}
            component={MDSwitchField}
          />
          <Field
            name="availablePlatforms"
            title={<Entity entity="samlAvailablePlatforms" />}
            component={MDCheckBoxGroupField}
            options={SAML_LOGIN_PLATFORM_OPTIONS}
            canSelectAll={false}
            horizontal
            containerstyle={{ paddingLeft: 0, marginTop: 20 }}
            checkboxesContainerStyle={{ justifyContent: 'flex-start', gap: 24 }}
          />
          <Entity
            title={<Entity entity="samlExtIdMapping" />}
            componentClass={Field}
            name="extIdMapping"
            componentAttribute="placeholder"
            entity="samlExtIdMappingPlaceholder"
            helpText={<Entity entity="samlExtIdMappingHelp" />}
            component={CustomField}
            type="text"
            containerStyle={{ marginTop: 24 }}
            className="form-control-custom"
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="samlUserProvisioningTitle"
          subtitle="samlUserProvisioningDescription"
          containerStyle={{ marginRight: 10, marginTop: 10 }}
        >
          <Field
            name="enableUserCreation"
            label={<Entity entity="samlEnableUserCreation" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold' }}
            component={MDSwitchField}
          />
          <Entity
            title={<Entity entity="samlFirstnameMapping" />}
            componentClass={Field}
            name="firstnameMapping"
            componentAttribute="placeholder"
            entity="samlFirstnameMappingPlaceholder"
            component={CustomField}
            type="text"
            disabled={samlProvisioningMappingDisabled}
            containerStyle={{ marginTop: 20 }}
            className="form-control-custom"
          />
          <Entity
            title={<Entity entity="samlLastnameMapping" />}
            componentClass={Field}
            name="lastnameMapping"
            componentAttribute="placeholder"
            entity="samlLastnameMappingPlaceholder"
            component={CustomField}
            type="text"
            disabled={samlProvisioningMappingDisabled}
            containerStyle={{ marginTop: 10 }}
            className="form-control-custom"
          />
          <Entity
            title={<Entity entity="samlUserTagMapping" />}
            componentClass={Field}
            name="userTagMapping"
            componentAttribute="placeholder"
            entity="samlUserTagMappingPlaceholder"
            component={CustomField}
            type="text"
            disabled={samlProvisioningMappingDisabled}
            containerStyle={{ marginTop: 10 }}
            className="form-control-custom"
          />
          <Entity
            title={<Entity entity="samlRoleMapping" />}
            componentClass={Field}
            name="roleMapping"
            componentAttribute="placeholder"
            entity="samlRoleMappingPlaceholder"
            component={CustomField}
            type="text"
            disabled={samlProvisioningMappingDisabled}
            containerStyle={{ marginTop: 10 }}
            className="form-control-custom"
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="identityManagerRoleSectionTitle"
          subtitle={isOfficeSSOActive ? 'identityManagerRoleSectionDescriptionWithScim' : 'identityManagerRoleSectionDescriptionSamlOnly'}
          containerStyle={{ marginRight: 10, marginTop: 10 }}
        >
          <Entity
            title={<Entity entity="identityManagerRoleValue" />}
            componentClass={Field}
            name="managerRoleValue"
            componentAttribute="placeholder"
            entity="identityManagerRoleValuePlaceholder"
            helpText={<Entity entity={isOfficeSSOActive ? 'identityManagerRoleValueHelpWithScim' : 'identityManagerRoleValueHelpSamlOnly'} />}
            component={CustomField}
            type="text"
            disabled={managerRoleValueDisabled}
            containerStyle={{ marginTop: 10 }}
            className="form-control-custom"
          />
        </FormFlatContainer>
        {isOfficeSSOActive ? (
          <Office365ScimProvisioningSection containerStyle={{ marginRight: 10, marginTop: 10, marginBottom: 80 }} />
        ) : (
          <div style={{ marginBottom: 80 }} />
        )}
      </div>
    );
  }
} 

export default SamlSsoConfigurationForm;
